<template>
  <!-- 本组件为：特定颜色的饼状图，如周报表格里的饼状图(充放比图等) -->
  <div>
    <el-popover placement="top-start" width="200" trigger="hover"
      :content="$t('allDeviceDetail.TotalChargeSinceInstallation')">
      <i slot="reference" class="el-icon-question"
        style="font-size:20px; color: #858585; position: absolute;bottom: 100px;left: 10px; z-index: 99;"></i>
    </el-popover>

    <div id="ahChart" :class="className" :style="{height:height,width:width}" />
  </div>

</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import i18n from '@/i18n'
import { thousandFn } from '@/utils/thousandFn.js'
import { temChange, temUnit } from '@/utils/temChange.js'
const animationDuration = 6000
var colorArr = ['#a9d252', '#1e90fc']
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    seriesData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chart: null,
      legendData: []
    }
  },
  watch: {
    seriesData: {
      handler (newValue, oldValue) {
        this.seriesData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      if (this.chart) {
        this.chart.clear()
      }
      this.seriesData.forEach(v => {
        // v.name = (v.name).toUpperCase()
        if (v.name == 'CHARGED') v.name = i18n.t('basicinfo.Charged')
        if (v.name == 'DISCHARGED') v.name = i18n.t('basicinfo.DisCharged')
        this.legendData.push(v.name)
      })
      // console.log(this.$el)
      this.chart = echarts.init(document.getElementById('ahChart'))
      var myOption = {
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c} ({d}%)'
          // formatter: '{b} : {c} ({d}%)',
          // formatter: this.formatter(b),
          formatter: (b) => {
            var m = thousandFn(b.value) || 0
            if (b.data.divClass == 'myPieChartSecond') {
              return b.name + ': ' + m + ' Ah' +
                '<br/>Lowest SOC: ' + Math.round(b.data.minSoc / 100) + ' %' +
                '<br/>Used Rate: ' + b.data.usedRate + ' %' +
                '<br/>Lowest voltage: ' + b.data.minVoltage / 100 + ' V' +
                '<br/>Highest temperature: ' + temChange(Math.round(b.data.maxTemprature / 100)) + temUnit()
            } else {
              return b.name + ': ' + m + ' Ah (' + b.percent + '%)'
            }
          },
          position: function (p) { // 其中p为当前鼠标的位置
            return [p[0] + 10, p[1] - 10]
          },
          textStyle: {
            align: 'left'
          }
        },
        legend: {
          left: '0',
          align: 'left',
          top: 'bottom',
          type: 'scroll',
          orient: 'vertical',
          data: this.legendData
        },
        // grid: {
        //   left: '33%',
        //   right: '4%',
        //   bottom: '15%',
        //   top: '2%',
        //   containLabel: false
        // },
        series: [
          {
            // name: 'WEEKLY WRITE ARTICLES',
            type: 'pie',
            // selectedOffset: 10,

            // roseType: 'radius',
            radius: '50%',
            center: ['65%', '50%'],
            selectedMode: 'single',
            color: colorArr,
            data: this.seriesData,
            // selected: true,
            itemStyle: {
              normal: {// 饼状图上的文本显示
                label: {
                  show: true,
                  // formatter: '{b}{c}({d}%)', // 数值和百分比
                  formatter: function (c) {
                    return thousandFn(c.value) || 0
                  },
                  textStyle: {
                    fontSize: 12
                  }
                },
                labelLine: { // 指示线状态
                  show: true,
                  smooth: 0.2,
                  length: 5,
                  length2: 5
                }
              }
            }
          }
        ]
      }
      this.chart.setOption(myOption, true)
    }
  }
}
</script>
